import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BasePageTitleData } from '../interfaces/base-page-title-data.interface';

@Injectable({ providedIn: 'root' })
export class BasePageTitleService {
  private titleDataSubject = new BehaviorSubject<BasePageTitleData>({
    title: '',
    translateParams: {},
  });

  titleData$: Observable<BasePageTitleData> = this.titleDataSubject.asObservable();

  setTitleData(title: string, translateParams?: Record<string, string>): void {
    this.titleDataSubject.next({
      title,
      translateParams: translateParams || {},
    });
  }
}
